import PropTypes from "prop-types";
import React, { useState } from "react";
import { Toast } from "@yoast/ui-library";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import * as styles from "./ProvisioningStyles.module.scss";

const AUTO_DISMISS_MS = 8000;

/**
 * Feedback for an action that has no modal of its own, or whose modal has already closed.
 *
 * Keyed by the caller so a second action replaces the toast instead of updating it in place:
 * the ui-library Toast reads `autoDismiss` only on mount.
 *
 * @param {Object} props Component props.
 *
 * @returns {JSX.Element} The toast.
 */
function ProvisioningActionToast( { variant, children, onDismiss } ) {
	const [ isVisible, setIsVisible ] = useState( false );
	const Icon = variant === "error" ? ExclamationCircleIcon : CheckCircleIcon;

	return (
		<Toast
			id="provisioning-action-toast"
			isVisible={ isVisible }
			setIsVisible={ setIsVisible }
			autoDismiss={ AUTO_DISMISS_MS }
			onDismiss={ onDismiss }
		>
			<div className={ styles.toastFlex }>
				<Icon
					className={ classNames( styles.toastIcon, variant === "error" ? styles.toastError : styles.toastSuccess ) }
					aria-hidden="true"
				/>
				<div>
					<div className={ styles.toastClose }>
						<Toast.Close dismissScreenReaderLabel="Dismiss" />
					</div>
					<p role="status">{ children }</p>
				</div>
			</div>
		</Toast>
	);
}

ProvisioningActionToast.propTypes = {
	variant: PropTypes.oneOf( [ "success", "error" ] ).isRequired,
	children: PropTypes.node.isRequired,
	onDismiss: PropTypes.func.isRequired,
};

export default ProvisioningActionToast;
